import { Routes, Route } from "react-router-dom";
import Checkout from "../pages/Checkout";
import Success from "../pages/Success";
import AdminOrders from "../pages/AdminOrders";
function AllRoute() {
  return (
    <Routes>
      <Route path="/checkout" element={<Checkout />}></Route>
      <Route path="/success" element={<Success />}></Route>
      <Route path="/adminOrders" element={<AdminOrders />}></Route>
    </Routes>
  );
}
export default AllRoute;
